import { useQuery, useQueryClient } from '@tanstack/react-query';
import { IntegrationsService } from '@api/services';
import { QueryKeys } from '@api/query';

export function useGetCatalogV2() {
  const queryClient = useQueryClient();

  const { data: integrationsConfigs, isFetched: isIntegrationsConfigsFetched } = useQuery({
    queryKey: [QueryKeys.CatalogV2],
    queryFn: async () => {
      const { data } = await IntegrationsService.appListIntegrationConfigs();

      data.forEach((config) => {
        queryClient.setQueryData([QueryKeys.CatalogV2, config.type], config);
      });

      return data;
    },
    initialData: [],
  });

  return {
    integrationsConfigs,
    isIntegrationsConfigsFetched,
  };
}

export function useGetIntegrationConfigV2(type: string) {
  const { data: integrationConfig, isFetched: isIntegrationConfigFetched } = useQuery({
    queryKey: [QueryKeys.Catalog, type],
    queryFn: async () => IntegrationsService.appGetIntegrationConfig({ type }),
  });

  return {
    integrationConfig,
    isIntegrationConfigFetched,
  };
}
